import * as React from "react";
import PropTypes from "prop-types";

type ReactCommentProps = {
  text: string
};

const ReactComment: React.FC<ReactCommentProps> = ({ text }) => {
  return <div className="html-comment" dangerouslySetInnerHTML={{ __html: `<!-- ${text} -->` }}></div>
};

ReactComment.propTypes = {
  //
};

export default ReactComment;
